import { useEffect } from 'react';
import { useApp } from '../store';
import { Deck } from './Deck';
import { Dialogs } from './Dialogs';
import { Header } from './Header';
import { Login } from './Login';
import { ConfirmDialog, ToastHost } from './Overlays';
import { Panel } from './Panel';
import { PrintSheet } from './PrintSheet';
import { WheelCard } from './WheelCard';

export function App() {
  const phase = useApp((s) => s.phase);
  const boot = useApp((s) => s.boot);
  const loadError = useApp((s) => s.loadError);

  useEffect(() => {
    void boot();
  }, [boot]);

  if (phase === 'loading')
    return (
      <div className="splash" aria-busy="true">
        <div className="splash-ring" />
        <p>Ielādē…</p>
      </div>
    );
  if (phase === 'error')
    return (
      <div className="splash">
        <h1>Balansa aplis</h1>
        <p className="bad">Neizdevās savienoties ar serveri: {loadError}</p>
        <button className="btn primary" onClick={() => location.reload()}>
          Mēģināt vēlreiz
        </button>
      </div>
    );
  if (phase === 'login')
    return (
      <>
        <Login />
        <ToastHost />
      </>
    );
  return <Main />;
}

function Main() {
  const tick = useApp((s) => s.tick);
  const sync = useApp((s) => s.syncFromServer);

  // Baterija mainās laikā — pārrēķins katru minūti un atgriežoties cilnē.
  // Izmaiņas no citiem klientiem (cita ierīce, AI aģents caur MCP) — pārbaude ik 10 s un atgriežoties cilnē.
  useEffect(() => {
    const h = setInterval(tick, 60_000);
    const hs = setInterval(() => {
      if (!document.hidden) void sync();
    }, 10_000);
    const vis = () => {
      if (!document.hidden) {
        tick();
        void sync();
      }
    };
    document.addEventListener('visibilitychange', vis);
    return () => {
      clearInterval(h);
      clearInterval(hs);
      document.removeEventListener('visibilitychange', vis);
    };
  }, [tick, sync]);

  // Esc: atceļ saites sākumu → izslēdz saišu režīmu → noņem izvēli.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const s = useApp.getState();
      if (s.dialog || s.confirm) return;
      if (s.ui.linkSrc) s.setUi({ linkSrc: null });
      else if (s.ui.mode === 'link') s.setLinkMode(false);
      else if (s.ui.selected) s.setUi({ selected: null });
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <div className="app">
        <Header />
        <main className="layout">
          <WheelCard />
          <Panel />
        </main>
        <Deck />
      </div>
      <Dialogs />
      <ConfirmDialog />
      <PrintSheet />
      <ToastHost />
    </>
  );
}
